import React, { useEffect, useState } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import { SELECTED_FEATURES } from "../../../../components/views/TenantSignUp/tenantSignUpConstants";

function DataControlPlatformChanges({ tenantDetails }) {
  const dispatch = useDispatch();

  const [dataControlEnabled, setDataControlEnabled] = useState(false);

  // Current selected features from Redux
  const selectedFeatures = useSelector(
    (state) => state.tenantSignUpReducer?.selectedFeatures || [],
  );

  // Get Data Control feature ID from tenantDetails.featuresData
  const dataControlFeatureId = tenantDetails?.featuresData?.find(
    (feature) => feature.name === "Data Control",
  )?.id;

  // Get Silver license ID from tenantDetails.licenceTypeData
  const silverLicenseId = tenantDetails?.licenceTypeData?.find(
    (license) => license.name === "Silver",
  )?.id;

  const alreadyExists = selectedFeatures.some(
    (feature) => feature.featureId === dataControlFeatureId,
  );
  const licenseExist = selectedFeatures.some(
    (feature) => feature.licenseTypeId === silverLicenseId,
  );

  // Decide toggle state from selectedFeatures
  useEffect(() => {
    if (!alreadyExists || !licenseExist) {
      setDataControlEnabled(false);
      return;
    }

    const dataControlSelected = selectedFeatures.some(
      (feature) => feature.featureId === dataControlFeatureId,
    );

    setDataControlEnabled(dataControlSelected);
  }, [dataControlFeatureId, selectedFeatures, alreadyExists, licenseExist]);

  const handleToggle = (event) => {
    const enabled = event.target.checked;

    if (!dataControlFeatureId) {
      return;
    }

    let updatedFeatures;

    if (enabled) {
      // Add Data Control if it isn't already present

      if (alreadyExists && licenseExist) {
        updatedFeatures = [...selectedFeatures];
      } else {
        updatedFeatures = [
          ...selectedFeatures,
          {
            featureId: dataControlFeatureId,
            licenseTypeId: silverLicenseId,
          },
        ];
      }
    } else {
      // Completely remove Data Control
      updatedFeatures = selectedFeatures.filter(
        (feature) => feature.featureId !== dataControlFeatureId,
      );
    }

    setDataControlEnabled(enabled);

    dispatch({
      type: SELECTED_FEATURES,
      payload: updatedFeatures,
    });
  };

  return (
    <div className="dataControlPlatform">
      <FormControlLabel
        classes={{
          label: "dataControlLabel",
        }}
        control={
          <Switch
            checked={dataControlEnabled}
            onChange={handleToggle}
            color="primary"
          />
        }
        label="Data Control"
      />
    </div>
  );
}

export default DataControlPlatformChanges;
